import { useEffect, useState } from "react";
import { IUpdateLicense } from "../UpdateLicense/interface";
import { authorizationService } from "../../../api_services/authorizationService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlusCircle, faTrash } from "@fortawesome/free-solid-svg-icons";
import Monaco, { useMonaco } from "@monaco-editor/react";
import "./Rule.scss";
import Loader from "../../Loader/Loader";
import MonaccoEditor from "../../MonacoEditor/MonacoEditor";
import { useSharedState } from "../../../../components/services/WindowSizeService";
import classNames from "classnames";
import { alertService } from "../../Services/alertService";
import { endSession, getURLDataMethod, noAccessMessage } from "../../../Utils/Utils";

const Rule = (props: IUpdateLicense) => {
    const { onClose, page } = props;
    const monaco = useMonaco();
    const windowSize$ = useSharedState();
    const [normalizerData, setNormalizerData] = useState<any>();
    const [suggestionsList, setSuggestionsList] = useState([]);
    const [monacoEditorFlag, setMonacoEditorFlag] = useState(false);
    const [loaderFlag, setLoaderFlag] = useState<boolean>(true);
    const [completionDisposable, setCompletionDisposable] = useState<any>();
    const [editMonaco, setEditMonaco] = useState<any>(false);
    const [monacoDefaultValue, setMonacoDefaultValue] = useState<string>();
    const [currentManoccoValue, setCurrentManoccoValue] = useState<string>();
    const [currentIndex, setCurrentIndex] = useState<any>();

    let payLoad: any = getURLDataMethod();

    useEffect(() => {
        if (page === "Normalizer") {
            getNormalizer()
        }
        else if (page === "RuleConfiguration") {
            getRule()
        }
    }, [])

    useEffect(() => {
        completionDisposable?.dispose();
        if (monacoDefaultValue) {
            setMonacoDefaultValue("");
        }
    }, [monacoEditorFlag])

    const editorOptions: any = {
        ariaLabel: 'iot editor',
        selectOnLineNumbers: false,
        lineNumbers: 'on',
        lineNumbersMinChars: 3,
        accessibilitySupport: 'off',
        cursorBlinking: 'smooth',
        // automaticLayout: true,
        smoothScrolling: true,
        suggestSelection: 'first',
        // revealHorizontalRightPadding: 20,
        // overviewRulerBorder: false,
        lineHeight: 25,
        theme: 'myCoolTheme',
        language: 'newlang', // 'javascript',
        autoIndent: false,
        folding: false,
        iconsInSuggestions: false,
        wordWrap: 'on', // 'wordWrapColumn',
        // wrappingIndent: 'same',
        minimap: {
            enabled: false,
        },
        wordBasedSuggestions: false,
        suggestFontSize: 10,
        autoClosingQuotes: 'always',
        acceptSuggestionOnCommitCharacter: false,
        scrollbar: {
            verticalScrollbarSize: 10,
        },
        contextmenu: false,
        // formatOnType: true,
        dragAndDrop: false,
        // roundedSelection: false,
        scrollBeyondLastLine: false,
        unfoldOnClickAfterEndOfLine: true,
        // readOnly: false,
    };

    useEffect(() => {
        return () => {
            if (typeof completionDisposable?.dispose === "function") {
                completionDisposable.dispose();
            }
        };
    }, [completionDisposable]);

    const closeModal = () => {
        onClose && onClose(false);
        completionDisposable?.dispose();
        setCompletionDisposable(completionDisposable);
        setSuggestionsList([]);
    }

    const getNormalizer = async () => {
        const payloadData = JSON.parse(JSON.stringify(payLoad));
        if (payloadData && payloadData['firmware_version']) {
            const device = payloadData['device_type'].split('iLens-')[1];
            try {
                return await authorizationService.getNormalizerData("NormalizerData", payloadData, device, payloadData['firmware_version']).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            let response = JSON.parse(JSON.stringify(res.body.data));
                            setNormalizerData(response?.normalizer_list);
                            setSuggestionsList(response?.suggestions);
                            setLoaderFlag(false);
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        noAccessMessage(res.response?.data?.message)
                    }
                    else {
                        console.log("error");
                    }
                })
            } catch (err: any) {
                console.log(err);
            }
        }
    }

    const getRule = async () => {
        const payloadData = JSON.parse(JSON.stringify(payLoad));
        if (payloadData && payloadData['firmware_version']) {
            const device = payloadData['device_type'].split('iLens-')[1];
            try {
                return await authorizationService.getRule("RuleData", payloadData, device, payloadData['firmware_version']).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            let response = JSON.parse(JSON.stringify(res.body.data));
                            setNormalizerData(response?.trigger_list);
                            setSuggestionsList(response?.suggestions);
                            setLoaderFlag(false);
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        noAccessMessage(res.response?.data?.message)
                    }
                    else {
                        console.log("error");
                    }
                })
            } catch (err: any) {
                console.log(err);
            }
        }
    }

    const enhanceSuggestions = (sList: any, range: any) => {
        sList.forEach((item: any) => {
            item["range"] = range;
        });
        return sList;
    }

    const updateNormalizer = async (reqNormalizerData: any) => {
        const payloadData = JSON.parse(JSON.stringify(payLoad));
        if (payloadData && payloadData['firmware_version']) {
            const device = payloadData['device_type'].split('iLens-')[1];
            payloadData["data"] = {
                "normalizer_list": reqNormalizerData
            }
            try {
                return await authorizationService.updateNormalizer("UpdateNormalizer", payloadData, device, payloadData['firmware_version']).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            let response = JSON.parse(JSON.stringify(res.body));
                            alertService.serviceSuccessMessage(response?.message);
                            getNormalizer()
                            setLoaderFlag(true);
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        noAccessMessage(res.response?.data?.message)
                    }
                    else {
                        console.log("error");
                    }
                })
            } catch (err: any) {
                console.log(err);
            }
        }
    }

    const updaterRule = async (reqNormalizerData: any) => {
        const payloadData = JSON.parse(JSON.stringify(payLoad));
        if (payloadData && payloadData['firmware_version']) {
            const device = payloadData['device_type'].split('iLens-')[1];
            payloadData["data"] = {
                "trigger_list": reqNormalizerData
            }
            try {
                return await authorizationService.updateRule("UpdateRule", payloadData, device, payloadData['firmware_version']).then((res: any) => {
                    if (res.status === 200) {
                        if (res.body) {
                            let response = JSON.parse(JSON.stringify(res.body));
                            alertService.serviceSuccessMessage(response?.message);
                            getRule()
                            setLoaderFlag(true);
                        }
                    }
                    else if (res.response?.status === 401) {
                        endSession()
                    }
                    else if (res.response?.status === 403) {
                        noAccessMessage(res.response?.data?.message)
                    }
                    else {
                        console.log("error");
                    }
                })
            } catch (err: any) {
                console.log(err);
            }
        }
    }

    const saveCustomNode = () => {
        let tempNormData: any = JSON.parse(JSON.stringify(normalizerData))
        setEditMonaco(false);
        setMonacoEditorFlag(false);
        tempNormData[currentIndex] = currentManoccoValue;
        if (page === "Normalizer") {
            setLoaderFlag(true);
            updateNormalizer(tempNormData)
        }
        else if (page === "RuleConfiguration") {
            setLoaderFlag(true);
            updaterRule(tempNormData)
        }
    }

    const editExistingValue = (index: number) => {
        setEditMonaco(true);
        setMonacoEditorFlag(true);
        setCurrentIndex(index);
        setMonacoDefaultValue(normalizerData[index])
    }

    const addRule = () => {
        setMonacoEditorFlag(true)
        setCurrentIndex(normalizerData?.length)
    }
    const deleteRule = (index: any) => {
        let tempNormData: any = JSON.parse(JSON.stringify(normalizerData))
        tempNormData.splice(index, 1);
        if (page === "Normalizer") {
            setLoaderFlag(true);
            updateNormalizer(tempNormData)
        }
        else if (page === "RuleConfiguration") {
            setLoaderFlag(true);
            updaterRule(tempNormData)
        }
    }
    // const editorWillMount = () => {
    //     monaco?.languages.register({ id: 'newlang' });
    //     setCompletionDisposable(
    //         monaco?.languages.registerCompletionItemProvider("newlang", {
    //             provideCompletionItems: function (model, position) {
    //                 var word = model.getWordUntilPosition(position);
    //                 var range = {
    //                     startLineNumber: position.lineNumber,
    //                     endLineNumber: position.lineNumber,
    //                     startColumn: word.startColumn,
    //                     endColumn: word.endColumn,
    //                 };
    //                 return {
    //                     suggestions: enhanceSuggestions(suggestionsList, range)
    //                 };
    //             },
    //         })
    //     );
    // };


    return (
        <div className="rule-modal">
            <div className={classNames("modal-body px-2 py-3 events-none",
                {
                    "drawer-body": windowSize$ === "sm" || windowSize$ === "xs",
                    "dr": windowSize$ === "md" || windowSize$ === "lg" || windowSize$ === "xl" || windowSize$ === "xxl"
                })}  >
                <>
                    {
                        !loaderFlag ?
                            <>
                                {monacoEditorFlag ?
                                    <>
                                        <div className="save-custom mx-2">
                                            <div className="add-icon m-2" onClick={() => { setMonacoEditorFlag(false) }}>
                                                <button type="button" className="btn btn-secondary" >Back</button>
                                            </div>
                                            <div>
                                                <button type="button" className="btn btn-primary" onClick={saveCustomNode}>Save Custom Node</button>
                                            </div>
                                        </div>
                                        {suggestionsList &&
                                            <MonaccoEditor
                                                defaultValue={monacoDefaultValue}
                                                data={suggestionsList}
                                                monacoEditorFlag={monacoEditorFlag}
                                                completionDisposable={completionDisposable}
                                                setCompletionDisposable={setCompletionDisposable}
                                                currentManoccoValue={currentManoccoValue}
                                                setCurrentManoccoValue={setCurrentManoccoValue}
                                            />
                                        }
                                    </>
                                    :
                                    <>
                                        <div className="add-icon m-2 pointer" onClick={() => { addRule() }}>
                                            <FontAwesomeIcon icon={faPlusCircle} /> Add Rule
                                        </div>
                                        <table className="table table-borderless tablerule fixed">
                                            <thead>
                                                <tr>
                                                    <th scope="col" style={{ width: "10%" }}>#</th>
                                                    <th scope="col" style={{ width: "70%" }}>Rule</th>
                                                    <th scope="col" style={{ width: "10%" }}>Edit</th>
                                                    <th scope="col" style={{ width: "10%" }}>Delete</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* {page === "Normalizer" && */}
                                                <>
                                                    {normalizerData?.map((item: any, index: number) => {
                                                        return (
                                                            <tr>
                                                                <td>{index + 1}</td>
                                                                <td>{normalizerData[index]}</td>
                                                                <td>
                                                                    <div className="pointer icon-custom-color" onClick={() => { editExistingValue(index) }}>
                                                                        <FontAwesomeIcon icon={faPencil} />
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="pointer icon-custom-color" onClick={() => { deleteRule(index) }}>
                                                                        <FontAwesomeIcon icon={faTrash} />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                    }
                                                </>
                                                {/* } */}

                                            </tbody>
                                        </table>
                                    </>
                                }
                            </>
                            :
                            <div className="center-align">
                                <Loader hasError={false} />
                            </div>
                    }
                </>
            </div >
            <div className="no-border-footer modal-footer justify-content-center" >
                <div className="dis">
                    <button attr-test="modal-submit" type="button" className="btn btn-secondary footer-button mr-2 set-qc-button" onClick={closeModal}>Cancel</button>
                    {/* <button attr-test="modal-submit" type="button" className="btn btn-primary footer-button set-qc-button" >Save</button> */}
                </div>
            </div>
        </div>
    )
}
export default Rule;

